import * as React from "react";

export const PlayButton: React.FC = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="22" cy="22" r="22" fill="#F5F5F5" />
      <path
        d="M32.3108 20.8412C33.4877 21.6339 33.4877 23.3661 32.3108 24.1588L19.4817 32.8002C18.1532 33.695 16.3643 32.7431 16.3643 31.1414L16.3643 13.8586C16.3643 12.2569 18.1532 11.305 19.4817 12.1998L32.3108 20.8412Z"
        fill="#474747"
      />
    </svg>
  );
};
